import {ElMessage, ElMessageBox} from 'element-plus';

// 后台页面连续无操作 30 分钟后退出登录。
export const IDLE_TIMEOUT = 30 * 60 * 1000;

let idleTimer = null;
let sessionExpiredPromptShown = false;
let idleMonitorStarted = false;
let sessionTerminated = false;

export function hasLoginToken() {
    return Boolean(window.sessionStorage.getItem('xtoken'));
}

export function clearLoginState() {
    window.sessionStorage.clear();
    window.localStorage.clear();
}

function redirectToLogin() {
    sessionTerminated = true;
    clearLoginState();
    if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
        window.location.replace('/login');
    }
}

export function handleSessionExpired() {
    if (sessionExpiredPromptShown || sessionTerminated) {
        return;
    }
    sessionExpiredPromptShown = true;

    ElMessageBox.confirm('登录状态已失效，请重新登录。', '登录状态失效', {
        confirmButtonText: '重新登录',
        cancelButtonText: '确定',
        type: 'warning',
        closeOnClickModal: true,
        closeOnPressEscape: true,
    }).finally(() => {
        redirectToLogin();
    });
}

function isLoginPage() {
    return window.location.pathname === '/login' || window.location.pathname === '/';
}

function resetIdleTimer() {
    if (idleTimer) {
        window.clearTimeout(idleTimer);
        idleTimer = null;
    }
    if (sessionTerminated || !hasLoginToken() || isLoginPage()) {
        return;
    }
    idleTimer = window.setTimeout(() => {
        if (sessionTerminated || !hasLoginToken() || isLoginPage()) {
            return;
        }
        sessionTerminated = true;
        clearLoginState();
        ElMessage.warning('长时间未操作，已退出登录。');
        window.location.replace('/login');
    }, IDLE_TIMEOUT);
}

export function startIdleMonitor() {
    if (idleMonitorStarted) {
        resetIdleTimer();
        return;
    }
    idleMonitorStarted = true;
    ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'].forEach(eventName => {
        window.addEventListener(eventName, resetIdleTimer, {passive: true});
    });
    resetIdleTimer();
}

export function stopIdleMonitor() {
    if (idleTimer) {
        window.clearTimeout(idleTimer);
        idleTimer = null;
    }
}
